import {
  getGetBrandsBrandIdAccountUrl,
  getGetV5BrandsBrandIdBoardsUrl,
  getGetV5BrandsBrandIdExportsYourPinsUrl,
  getGetV5BrandsBrandIdPinsUrl,
  getPostV5BrandsBrandIdBoardsUrl,
} from '@dashhudson/api-client/pinterest/client';
import merge from 'lodash/merge';

import { createDashHttpClient } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.pinterestApiUrl);

export function getPinterestAccounts({ brandIds }, config = {}) {
  return http.get(
    `/brands/accounts`,
    merge(
      {
        params: {
          brandIds: brandIds?.join(','),
        },
      },
      config,
    ),
  );
}

export function getBoards({ brandId }, config = {}) {
  return http.get(getGetV5BrandsBrandIdBoardsUrl(brandId), config);
}

export function createBoard({ brandId, name }, config = {}) {
  return http.post(getPostV5BrandsBrandIdBoardsUrl(brandId), { name }, config);
}

export function getPinterestAccount({ brandId }, config = {}) {
  return http.get(
    getGetBrandsBrandIdAccountUrl(brandId),
    merge(
      {
        camelizeKeys: true,
      },
      config,
    ),
  );
}

export async function getMetrics({ brandId, startDate, endDate }, config = {}) {
  return http.get(
    `/v5/brands/${brandId}/metrics/account`,
    merge(
      {
        params: {
          startDate,
          endDate,
        },
      },
      config,
    ),
  );
}

export async function getPins(
  { brandId, startDate, endDate, sort, limit, privacy, has7dInsights, pinTypes, offset },
  config = {},
) {
  return http.get(
    getGetV5BrandsBrandIdPinsUrl(brandId),
    merge(
      {
        params: {
          startDate,
          endDate,
          sort,
          limit,
          privacy,
          has7dInsights,
          pinTypes: pinTypes?.join(','),
          offset,
        },
      },
      config,
    ),
  );
}

export async function getTopPins({ brandId, startDate, endDate, sort, limit }, config = {}) {
  return http.get(
    `/v5/brands/${brandId}/metrics/top_pins`,
    merge(
      {
        params: { startDate, endDate, sort, limit },
      },
      config,
    ),
  );
}

export async function getAnalyticsPinMetricsExport(
  { brandId, startDate, endDate, filename, scale },
  config = {},
) {
  return http.get(
    `/v5/brands/${brandId}/exports/metrics/account`,
    merge(
      {
        params: {
          startDate,
          endDate,
          filename,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getAnalyticsTopPinsExport(
  { brandId, startDate, endDate, filename, sort },
  config = {},
) {
  return http.get(
    `/v5/brands/${brandId}/exports/metrics/top_pins`,
    merge(
      {
        params: {
          startDate,
          endDate,
          filename,
          sort,
        },
      },
      config,
    ),
  );
}

export async function getYoursPinsExport(
  { brandId, startDate, endDate, pinTypes, privacy },
  config = {},
) {
  return http.get(
    getGetV5BrandsBrandIdExportsYourPinsUrl(brandId),
    merge(
      {
        params: {
          startDate,
          endDate,
          pinTypes: pinTypes?.join(','),
          privacy,
        },
      },
      config,
    ),
  );
}
